import React from 'react';
import ConfigurableLink from 'swag-client-common/components/utils/configurable-link';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
export const SideMenuSavedDesign = ({
  useHardLinks,
  onToggle,
  routeNavigationConfirmation
}) => {
  return /*#__PURE__*/React.createElement(ConfigurableLink, {
    routeNavigationConfirmation: routeNavigationConfirmation,
    isHardLink: useHardLinks && !routeNavigationConfirmation,
    link: APP_ROUTES.ACCOUNT_SAVED_DESIGNS,
    onClick: () => onToggle(false)
  }, "My saved designs");
};